module.exports = __webpack_public_path__ + "assets/216f152b89d0e30db6a610f8edbd0cbe.png";